export interface FileDownloadOptions {
    destPath: string;
    headers?: { [key: string]: string };
    id?: string;
    retries?: number;
}

export interface FileDownloadProgressEvent {
    id: string;
    loaded: number;
    total: number;
    percent: number;
}

export interface FileDownloadCompleteEvent {
    id: string;
    path: string;
}

export interface FileDownloadErrorEvent {
    id: string;
    error: any;
}

export interface FileDownloadQueueItem {
    id: string;
    url: string;
    status: string;
    percent: number;
}

interface CordovaFileDownloaderPlugin {
    enqueue(
        url: string,
        options: FileDownloadOptions,
        onProgress?: (event: FileDownloadProgressEvent) => void,
        onComplete?: (event: FileDownloadCompleteEvent) => void,
        onError?: (event: FileDownloadErrorEvent) => void
    ): string;
    cancel(id: string, success?: () => void, error?: (err: any) => void): void;
    getQueue(callback: (queue: FileDownloadQueueItem[]) => void, error?: (err: any) => void): void;
    clearQueue(success?: () => void, error?: (err: any) => void): void;
    getDownloadDirectory(callback: (path: string) => void, error?: (err: any) => void): void;
    open(path: string, success?: () => void, error?: (err: any) => void): void;
}

class _FileDownloaderServices {

    get plugin(): CordovaFileDownloaderPlugin {
        return (<any>window).cordova?.plugins?.FileDownloader;
    }

    get isAvailable(): boolean {
        return !!this.plugin;
    }

    enqueue(url: string, options: FileDownloadOptions, onProgress?: (event: FileDownloadProgressEvent) => void): Promise<FileDownloadCompleteEvent> {
        return new Promise<FileDownloadCompleteEvent>((resolve, reject) => {
            this.plugin.enqueue(
                url,
                options,
                onProgress,
                result => resolve(result),
                error => reject(error)
            );
        });
    }

    cancel(id: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.plugin.cancel(id, () => resolve(), error => reject(error));
        });
    }

    getQueue(): Promise<FileDownloadQueueItem[]> {
        return new Promise<FileDownloadQueueItem[]>((resolve, reject) => {
            this.plugin.getQueue(queue => resolve(queue), error => reject(error));
        });
    }

    clearQueue(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.plugin.clearQueue(() => resolve(), error => reject(error));
        });
    }

    getDownloadDirectory(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            this.plugin.getDownloadDirectory(path => resolve(path), error => reject(error));
        });
    }

    openFile(path: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.plugin.open(path, () => resolve(), error => reject(error));
        });
    }
}

export let FileDownloaderServices = new _FileDownloaderServices();
